var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragAndDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.5 7C2.32843 7 3 6.32843 3 5.5C3 4.67157 2.32843 4 1.5 4C0.67157 4 0 4.67157 0 5.5C0 6.32843 0.67157 7 1.5 7ZM1.5 13.5C2.32843 13.5 3 12.8284 3 12C3 11.1716 2.32843 10.5 1.5 10.5C0.67157 10.5 0 11.1716 0 12C0 12.8284 0.67157 13.5 1.5 13.5ZM3 18.5C3 19.3284 2.32843 20 1.5 20C0.67157 20 0 19.3284 0 18.5C0 17.6716 0.67157 17 1.5 17C2.32843 17 3 17.6716 3 18.5ZM8.5 7C9.3284 7 10 6.32843 10 5.5C10 4.67157 9.3284 4 8.5 4C7.6716 4 7 4.67157 7 5.5C7 6.32843 7.6716 7 8.5 7ZM10 12C10 12.8284 9.3284 13.5 8.5 13.5C7.6716 13.5 7 12.8284 7 12C7 11.1716 7.6716 10.5 8.5 10.5C9.3284 10.5 10 11.1716 10 12ZM8.5 20C9.3284 20 10 19.3284 10 18.5C10 17.6716 9.3284 17 8.5 17C7.6716 17 7 17.6716 7 18.5C7 19.3284 7.6716 20 8.5 20Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragAndDrop);
export default __webpack_public_path__ + "static/media/drag-and-drop.b22c4842550e5ca0ab84cb6960d31aca.svg";
export { ForwardRef as ReactComponent };